import { textTestimonials, videoTestimonials } from "@/mocks/testimonials";

export default function TestimonialsSection() {
  return (
    <section id="testimonials" className="section-padding scroll-mt-24 bg-background-50">
      <div className="max-w-6xl mx-auto">
        {/* Header */}
        <div className="text-center mb-16">
          <h2 className="font-heading text-3xl md:text-4xl font-bold text-primary-800 mb-2">
            Real Stories. Real Shifts.
          </h2>
        </div>

        {/* Text Testimonials */}
        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-6">
          {textTestimonials.map((t, i) => (
            <div
              key={i}
              className="bg-background-100 rounded-xl p-6 hover:scale-[1.03] hover:-translate-y-[4px] hover:shadow-lg transition-all duration-300 ease-out"
            >
              <div className="w-6 h-6 flex items-center justify-center mb-3">
                <i className="ri-double-quotes-l text-2xl text-primary-300" />
              </div>
              <p className="text-sm leading-relaxed mb-4 italic text-foreground-700">
                {t.quote}
              </p>
              <p className="font-heading font-semibold text-sm text-primary-700">
                {t.author}
              </p>
            </div>
          ))}
        </div>

        {/* Video Testimonials */}
        <div className="mt-14">
          <div className="text-center mb-10">
            <h3 className="font-heading text-2xl md:text-3xl font-semibold text-primary-800 mb-2">
              Watch Video Testimonials
            </h3>
            <p className="text-sm text-center max-w-md mx-auto text-foreground-600">
              Hear directly from clients about their experience working with Federica.
            </p>
          </div>

          <div className="grid md:grid-cols-2 gap-8 max-w-3xl mx-auto">
            {videoTestimonials.map((v) => (
              <div key={v.name} className="flex flex-col items-center gap-3">
                <h4 className="font-heading text-lg font-semibold text-primary-800">
                  {v.name}
                </h4>
                <div className="rounded-2xl overflow-hidden w-full max-w-[315px]">
                  <div className="relative w-full" style={{ paddingBottom: "177.78%" }}>
                    <iframe
                      className="absolute inset-0 w-full h-full"
                      src={v.embedUrl}
                      title={v.title}
                      frameBorder="0"
                      allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
                      allowFullScreen
                    />
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}